import Reveal from "./Reveal";

const REVIEWS = [
  {
    name: "Dorothy W.",
    text: "It was a very satisfying and pleasant experience dealing with Will French in the selling of my home. He was extremely knowledgeable, empathetic, and was able to offer solutions to any situation that arose. I could not have asked for a more thorough and transparent agent. I would highly recommend him to anyone either selling or buying property. He's really an asset to the company he represents.",
  },
  {
    name: "Kelly",
    text: "Working with Will French from CHK Real Estate to sell our condo was a great experience from start to finish. Will was professional, knowledgeable, and incredibly responsive throughout the entire process... I would highly recommend Will French and the team at CHK Real Estate. We couldn't be happier with the service we received!",
  },
  {
    name: "Stephen F.",
    text: "Open, honest communication and quick to reply to inquiries. Experienced, reliable Realtors with good knowledge of area sales and trends.",
  },
];

const STATS = [
  ["5+", "Years In Business"],
  ["$75M+", "Career Sales"],
  ["$850M+", "Team Career Sales"],
  ["101+", "Team 5 Star Google Reviews"],
  ["Top 1%", "TRREB Team Performance"],
];

export default function AboutWill() {
  return (
    <section id="about" className="bg-white py-20 sm:py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-14 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
        <Reveal className="relative">
          <div className="border border-hairline bg-white p-1.5">
            <img
              src="https://media-production.lp-cdn.com/cdn-cgi/image/format=auto,quality=85,fit=scale-down,width=1280/https://media-production.lp-cdn.com/media/8af3ebb4-8cb1-4d2f-86dc-13b5e3fdb76e"
              alt="Will French, REALTOR® — CHK Real Estate"
              data-testid="about-headshot"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          <span className="absolute -bottom-3 -right-3 hidden h-24 w-24 border-b-2 border-r-2 border-gold sm:block" />
        </Reveal>

        <div>
          <Reveal>
            <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-ink">
              Meet Will French
            </p>
            <h2 className="font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Integrity, discretion, unparalleled results.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-[15px] font-light leading-relaxed text-smoke sm:text-base">
              <p>
                Will helps clients of all property types, with specializations in waterfront homes,
                luxury builds and commercial spaces. He built his career on a deep understanding of
                market dynamics and a commitment to exceeding client expectations — backed by the
                award-winning team at CHK Real Estate.
              </p>
              <p>
                To Will, your property is not a mere transaction but a seamless adventure guided by a
                trusted friend with the expertise of a top-tier REALTOR®. From the initial
                consultation to the final closing, he is dedicated to understanding your unique
                preferences, lifestyle needs, and investment goals.
              </p>
            </div>
            <p className="mt-7 font-serif text-2xl italic text-ink">
              "Where There's a Will; There's a Way."
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 grid grid-cols-2 gap-px border border-hairline bg-hairline sm:grid-cols-3 lg:grid-cols-5">
              {STATS.map(([v, l]) => (
                <div key={l} className="bg-white p-5">
                  <p className="font-serif text-2xl text-ink sm:text-[1.7rem]">{v}</p>
                  <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-smoke">
                    {l}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-10 text-[11px] font-semibold uppercase tracking-[0.3em] text-ink">
              5 Star Google Reviews
            </p>
            <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3" data-testid="reviews-grid">
              {REVIEWS.map((r) => (
                <figure key={r.name} className="flex h-full flex-col border border-hairline bg-ivory p-6 sm:p-7" data-testid="review-card">
                  <span className="font-serif text-4xl leading-none text-ink">"</span>
                  <blockquote className="-mt-2 flex-1 text-[13px] font-light leading-relaxed text-ink">
                    {r.text}
                  </blockquote>
                  <figcaption className="mt-4 text-[10px] font-semibold uppercase tracking-[0.24em] text-smoke">
                    — {r.name} · 5 Star Google Review
                  </figcaption>
                </figure>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}